<template>
  <div class="invoice-missing-id">
    <h1>Oy.</h1>
    <h2>
      You're here by accident or because we were unable to process your order.
    </h2>
    <v-divider class="my-2"></v-divider>
    <h3>
      Please
      <v-btn
        small
        color="deep-orange"
        depressed
        :to="{ name: newOrderRoute, params: $route.params }"
      >
        try again
      </v-btn>
      or
      <v-btn
        small
        outlined
        color="grey darken-1"
        :href="`mailto:${getShopDetail('Contact Email')}`"
      >
        email us
      </v-btn>
      if this continues to be a problem.
    </h3>
  </div>
</template>

<script>
import { GuestRoutes } from '@/constants/RouteNames'
import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceMissingID',
  components: {},
  data() {
    return {
      newOrderRoute: GuestRoutes.NEW_ORDER,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
}
</script>
